import React, {useEffect, useRef, useState} from "react";
import {
    BUTTON, CLOSE,
    CREATE_QUESTION_TUTORIAL_DESC, LEARN_MORE_ABOUT_QUESTION_TYPE, OPEN_EXTERNAL_PLAYER,
    QUESTION_TYPES,
} from "../utils/constants";
import {ReactComponent as EXTERNAL} from "../images/external-purple-icon.svg";
import {ReactComponent as QUESTION_MARKER} from "../images/question_marker_purple.svg";
import { ReactComponent as ModalClose } from "../images/modal_close.svg";
import reportClasses from "../pages/Report/Report.module.css";
import classes from "./CreateQuestionVideoGuidance.module.css";
import Skeleton from "react-loading-skeleton";
import useWindowDimensions from "../hooks/useWindowDimensions";
import styles from "./questions.module.css";
import {generateUUID} from "../utils/helpers";
import {Button} from "@base-ui/react/button";
import { Popover } from '@base-ui/react/popover';



export default function CreateQuestionVideoGuidance({questionType="MCSS"}) {
    const URL_MAPPING = {
        MCSS: "https://demo.video.yuja.com/V/Video?v=15091544&node=64519283&a=118892452",
        SA: "https://demo.video.yuja.com/V/Video?v=15091575&node=64519352&a=14133590",
        TF: "https://demo.video.yuja.com/V/Video?v=15091586&node=64519377&a=80223037",
        FITB: "https://demo.video.yuja.com/V/Video?v=15091623&node=64519472&a=17451564",
        CI: "https://demo.video.yuja.com/V/Video?v=15091456&node=64518994&a=131283697",
        WC: "https://demo.video.yuja.com/V/Video?v=15091481&node=64519093&a=138805561",
        MH: "https://demo.video.yuja.com/V/Video?v=15091514&node=64519188&a=102762240",
        RK: "https://demo.video.yuja.com/V/Video?v=15091524&node=64519231&a=78683247",
        OE: "https://demo.video.yuja.com/V/Video?v=15091649&node=64519556&a=62909440",
        IB: "https://demo.video.yuja.com/V/Video?v=15091663&node=64519607&a=9255208",
        RETRO: "https://demo.video.yuja.com/V/Video?v=15091666&node=64519623&a=35055669",
        BS: "https://demo.video.yuja.com/V/Video?v=15091668&node=64519626&a=45062471",
    }

    const [randomId, ] = useState(() => generateUUID());
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true)
    const linkRef = useRef();
    const containerRef = useRef();
    let {width: windowWidth} = useWindowDimensions();
    const [isOnLeft, setIsOnLeft] = useState(true);
    const [guidanceWindowWidth, setGuidanceWindowWidth] = useState(500);


    useEffect(() => {
        if (!isOpen) {
            setIsLoading(true);

        }
    }, [isOpen]);


    useEffect(() => {
        resetContainerPosition();

    }, [windowWidth, linkRef]);

    const resetContainerPosition = () => {
        const guidanceWindowWidth = Math.min(windowWidth * 0.4, 500);
        setGuidanceWindowWidth(guidanceWindowWidth);
    }
    return (
        <Popover.Root
            modal={"trap-focus"}
            open={!!isOpen}
            onOpenChange={(open) => setIsOpen(open)}
        >
            <Popover.Trigger
                delay={0}
                aria-label={`Open tutorial video`}
                className={`${styles.infoIcon} ${isOpen ? styles.active : ""}`}
            >
                <QUESTION_MARKER aria-hidden="true" focusable="false"/>
            </Popover.Trigger>
            <Popover.Portal>
                <Popover.Positioner
                    sideOffset={10}
                    align={"start"}
                    style={{zIndex: 1}}
                >
                    <Popover.Popup
                        ref={containerRef}
                        tabIndex={0}
                        initialFocus={containerRef}
                        style={{width: guidanceWindowWidth}}
                        className={classes.Popup}
                    >
                        <Popover.Arrow className={classes.Arrow}>
                            <ArrowSvg aria-hidden="true" focusable="false"/>
                        </Popover.Arrow>


                        {/*<Button*/}
                        {/*    aria-label={CLOSE.substring(0, -1)}*/}
                        {/*    style={{zIndex: 10}}*/}
                        {/*    onClick={() => setIsOpen(false)}*/}
                        {/*    className="modal-close"*/}
                        {/*>*/}
                        {/*    <ModalClose/>*/}
                        {/*</Button>*/}


                        <Popover.Viewport className={classes.Body}>
                            <Popover.Title className={classes.Title}>
                                {QUESTION_TYPES[questionType]?.description}
                            </Popover.Title>

                            <Popover.Description className={classes.Description}>
                                {CREATE_QUESTION_TUTORIAL_DESC}
                                <Button
                                    style={{marginLeft: 3}}
                                    aria-label={OPEN_EXTERNAL_PLAYER}
                                    onClick={() => window.open(URL_MAPPING[questionType], "blank")}
                                >
                                    <EXTERNAL aria-hidden="true" focusable="false"/>
                                </Button>
                            </Popover.Description>


                            <Popover.Close
                                aria-label={CLOSE}
                                // style={{zIndex: 10}}
                                onClick={() => setIsOpen(false)}
                                className="modal-close"

                            >
                                <ModalClose aria-hidden="true" focusable="false"/>
                            </Popover.Close>
                        </Popover.Viewport>
                        {isLoading &&
                            <div style={{
                                width: "100%",
                                height: guidanceWindowWidth * 9 / 16,
                                display: "flex",
                                flexDirection: "column",
                                padding: 20,
                                gap: 20
                            }}>
                                <div style={{flex: 1}}/>
                                <Skeleton borderRadius={10} height={25} inline={true} width={"20%"}
                                          className={reportClasses.cardNumberSkeleton}
                                          containerClassName={reportClasses.cardNumberSkeletonWrapper}
                                />
                                <Skeleton borderRadius={10} height={25} inline={true} width={"30%"}
                                          className={reportClasses.cardNumberSkeleton}
                                          containerClassName={reportClasses.cardNumberSkeletonWrapper}
                                />
                                <Skeleton borderRadius={10} height={25} inline={true} width={"50%"}
                                          className={reportClasses.cardNumberSkeleton}
                                          containerClassName={reportClasses.cardNumberSkeletonWrapper}
                                />
                                <div style={{flex: 1}}/>
                            </div>
                        }


                        <iframe
                            title={`${QUESTION_TYPES[questionType]?.description} question creation tutorial video`}
                            data-yuja-iframe-id={randomId}
                            onLoad={() => {
                                setTimeout(() => {
                                    setIsLoading(false);
                                }, 1000)
                            }}
                            allowFullScreen
                            style={{
                                width: "100%",
                                height: guidanceWindowWidth * 9 / 16,
                                display: isLoading ? "none" : "block"
                            }}
                            src={URL_MAPPING[questionType]}
                        />

                    </Popover.Popup>

                </Popover.Positioner>
            </Popover.Portal>
        </Popover.Root>

    );
}


function ArrowSvg(props) {
    return (
        <svg width="20" height="10" viewBox="0 0 20 10" fill="none" {...props}>
            <path
                d="M9.66437 2.60207L4.80758 6.97318C4.07308 7.63423 3.11989 8 2.13172 8H0V10H20V8H18.5349C17.5468 8 16.5936 7.63423 15.8591 6.97318L11.0023 2.60207C10.622 2.2598 10.0447 2.25979 9.66437 2.60207Z"
                className={classes.ArrowFill}
            />
            <path
                d="M8.99542 1.85876C9.75604 1.17425 10.9106 1.17422 11.6713 1.85878L16.5281 6.22989C17.0789 6.72568 17.7938 7.00001 18.5349 7.00001L15.89 7L11.0023 2.60207C10.622 2.2598 10.0447 2.2598 9.66436 2.60207L4.77734 7L2.13171 7.00001C2.87284 7.00001 3.58774 6.72568 4.13861 6.22989L8.99542 1.85876Z"
                className={classes.ArrowOuterStroke}
            />
            <path
                d="M10.3333 3.34539L5.47654 7.71648C4.55842 8.54279 3.36693 9 2.13172 9H0V8H2.13172C3.11989 8 4.07308 7.63423 4.80758 6.97318L9.66437 2.60207C10.0447 2.25979 10.622 2.2598 11.0023 2.60207L15.8591 6.97318C16.5936 7.63423 17.5468 8 18.5349 8H20V9H18.5349C17.2998 9 16.1083 8.54278 15.1901 7.71648L10.3333 3.34539Z"
                className={classes.ArrowInnerStroke}
            />
        </svg>
    );
}